var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _c("h2", [
            _vm._v(
              "\n    " +
                _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                " Notifications\n\n    "
            ),
            _vm.userCanNotifyTalent
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-sm pull-right",
                    attrs: {
                      "data-toggle": "modal",
                      "data-backdrop": "static",
                      "data-target": "#talent-nofications-modal",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(
                      " Add " +
                        _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.haveNoTalentNotified
            ? _c("div", { staticClass: "text-center alert alert-default" }, [
                _vm._v(
                  "\n    There are no notified " +
                    _vm._s(_vm.$starLabelPlural) +
                    ".\n  "
                ),
              ])
            : _c(
                "ul",
                { staticClass: "tags" },
                _vm._l(_vm.booking.talent_notified, function (talent) {
                  return _c("li", { key: talent.id }, [
                    _c("span", [_vm._v(_vm._s(talent.name))]),
                  ])
                }),
                0
              ),
          _vm._v(" "),
          _c("booking-talent-notifications-modal", {
            ref: "modal",
            attrs: {
              booking: _vm.booking,
              recommendations: _vm.recommendations,
              "send-talent-notifications-callback":
                _vm.handleSendTalentNotificationsCallback,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }